// const BASE_URL = 'https://ihfc.candidate.physus.org:8989';
// export const BASE_URL = "http://192.168.1.36:8989";
export const BASE_URL = "https://engine.ihfc.trainer.mcitiservices.com";
// const url = "http://localhost:8989";
// export const BASE_URL = "http://localhost:8989";
// const url = "http://localhost:8989";
// export const BASE_URL = "https://engine.ihfc.trainer.mcitiservices.com";

const webserviceUrl = {
  login: `${BASE_URL}/login`,
  get_batches: `${BASE_URL}/get_batches`,
  add_units: `${BASE_URL}/add_units`,
  add_subUnits: `${BASE_URL}/add_subUnits`,
  update_subunits: `${BASE_URL}/update_subunits`,
  delete_subunit: `${BASE_URL}/delete_subunit`,
  view_units: `${BASE_URL}/view_units`,
  get_subunits: `${BASE_URL}/get_subunits`,
  update_units: `${BASE_URL}/update_units`,
  delete_units: `${BASE_URL}/delete_units`,
  view_attendence: `${BASE_URL}/view_attendence`,
  mark_attendence: `${BASE_URL}/mark_attendence`,
  get_student_documents: `${BASE_URL}/form_title_seq`,
  upload_student_documents: `${BASE_URL}/trainer_uploads`,
  final_submit_student_documents: `${BASE_URL}/submission`,
  upload_assessment: `${BASE_URL}/upload_assessment`,
  view_assessment: `${BASE_URL}/view_assessment`,
  get_lesson_units: `${BASE_URL}/get_lesson_units`,
  get_trainer_submission: `${BASE_URL}/get_trainer_submission`,
  delete_trainer_submission: `${BASE_URL}/delete_trainer_submission`,
  student_list: `${BASE_URL}/student-list`,
  photos_upload: `${BASE_URL}/photos/upload`,
  get_community_threads: `${BASE_URL}/get_community_threads`,
  delete_post: `${BASE_URL}/delete_post`,
  post_community_thread: `${BASE_URL}/post_community_thread`,
  post_comment: `${BASE_URL}/post-comment`,
  update_support_status: `${BASE_URL}/update-support-status`,
  myPhotos: `${BASE_URL}/photos/my-uploads`,
  get_configuration: `${BASE_URL}/student-course/configuration`,
  edit_configuration: `${BASE_URL}/student-course/configuration`,
  // all_programs: `http://192.168.1.6:8585/all-programs`
  all_programs: `https://engine.ihfc.candidate.mcitiservices.com/all-programs`,
};

export default webserviceUrl;
